export enum ConnectSettingActionsTypes {
  READ = "@@CONNECT_SETTING read connect settings",
  READ_STATUS = "@@CONNECT_SETTING read status connect settings",
  PATCH = "@@CONNECT_SETTING patch connect settings",
  PATCH_STATUS = "@@CONNECT_SETTING patch status connect settings",
  READ_AVAILABLE = "@@CONNECT_SETTING read available connect settings",
  READ_AVAILABLE_STATUS = "@@CONNECT_SETTING read status available connect settings"
}
